import Index from '../pages/index'
import Create from "../pages/create/create";
import Details from "../pages/details/details"
import {routeCreator} from '../../../helpers/routeCreator'

export const ROUTE_PAGE_USERS_INDEX = routeCreator(Index, '/users', 'Users', 'page.users', {exact: true})
export const ROUTE_PAGE_USERS_CREATE = routeCreator(Create, '/users/create', 'User Create', 'page.users.create', {exact: true})
export const ROUTE_PAGE_USERS_EDIT = routeCreator(Create, '/users/edit/:id', 'User Edit', 'page.users.edit', {exact: true})
export const ROUTE_PAGE_USERS_DETAILS = routeCreator(Details, '/users/details/:id', 'User Details', 'page.users.details', {exact: true})

const router = {
    ROUTE_PAGE_USERS_INDEX,
    ROUTE_PAGE_USERS_CREATE,
    ROUTE_PAGE_USERS_EDIT,
    ROUTE_PAGE_USERS_DETAILS
}

export default router